export default __webpack_public_path__ + "static/media/07-EXT-(4-2).16d31751.jpg";